import { useMemo } from 'react'
import history from '../store/history'

import { extractPathParams } from '../utils/extractPathParams'

const useUrlParam = (urlSchema) =>
  useMemo(() => {
    const url = history.location.pathname
    return extractPathParams(url, urlSchema)
  }, [urlSchema])

export default useUrlParam
